import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import PostArtikulli from "@/components/share/PostArtikulli.vue";
import postReport from "@/components/share/PostReport.vue";
import ViktimateKrimit from "@/components/pages/ViktimateKrimit.vue";

// Dokumentet
import LegislationPage from "@/components/pages/LegislationPage.vue";
import Legislation from "@/components/pages/LegislationShow.vue";

// Menu
import VlersimiPerformances from "@/components/pages/VlersimiPerformances.vue";
import disiplinimi from "@/components/pages/DisiplinimiPage.vue";
import Etika from "@/components/pages/EtikaProfesionale.vue";
import DocumentPage from "@/components/pages/DocumentPage.vue";
import gallery from '../components/pages/GalleryImage.vue';

// System
import SistemiProkurorial from '@/layouts/SistemiProkurorial.vue';
import VendimetPage from "@/components/pages/VendimetPage.vue";
import LatestNewsPage from "@/components/pages/LatestNewsPage.vue";
import KujdestaritContact from '../components/share/KujdestaritContact.vue'
import zmnvcontact from '../components/share/Zmnv-contact.vue'

// zkpsh
import aboutus_zkpsh from '../Prokurorit/ProkuroriShtetit/AboutUs.vue'

import ProsecutorChief from '../Prokurorit/ProkuroriShtetit/ProsecutorChief.vue'
//import Prosecutorszkpsh from '../Prokurorit/ProkuroriShtetit/ProsecutorView.vue'
import Coordinatorszkpsh from '../Prokurorit/ProkuroriShtetit/CoordinatorsView.vue'
import zmnvzkpsh from '../Prokurorit/ProkuroriShtetit/ZmnvView.vue'
import njnpzkpshview from '../Prokurorit/ProkuroriShtetit/NjnpView.vue'
import zrazkpsh from '../Prokurorit/ProkuroriShtetit/ZraView.vue'
import zkp_zkpsh from '../Prokurorit/ProkuroriShtetit/ZkpView.vue'
import marredheniamepublikun from '../Prokurorit/ProkuroriShtetit/MarredheniamePublikun.vue'
import kontakt_zkpsh from '../Prokurorit/ProkuroriShtetit/KontaktiView.vue'

// Prokuroia Apelit
import aboutus_pa from '../Prokurorit/ProkuroriaApelit/AboutUs.vue'
import chief_pa from '../Prokurorit/ProkuroriaApelit/ProsecutorChief.vue'
import kontakt_pa from '../Prokurorit/ProkuroriaApelit/KontaktiView.vue'
import AboutUsPa from "../Prokurorit/ProkuroriaApelit/AboutUsPa.vue";

//Prokuroria Speciale
import aboutus_ps from "../Prokurorit/ProkuroriaSpeciale/AboutUs.vue";
import chief_ps from "../Prokurorit/ProkuroriaSpeciale/ProsecutorChief.vue";
import kontakt_ps from "../Prokurorit/ProkuroriaSpeciale/KontaktiView.vue";
import AboutUsPs from "../Prokurorit/ProkuroriaSpeciale/AboutUsPs.vue";

//Prokuroria Speciale
import aboutus_pthprishtine from "../Prokurorit/PthPrishtine/AboutUs.vue";
import chief_pthprishtine from "../Prokurorit/PthPrishtine/ProsecutorChief.vue";
import kontakt_pthprishtine from "../Prokurorit/PthPrishtine/KontaktiView.vue";
import AboutUsPthPrishente from "../Prokurorit/PthPrishtine/AboutUsPthPrishente.vue";
import KontaktPthPrishtine from "../Prokurorit/PthPrishtine/KontaktPthPrishtine.vue";

//KPK
import AboutUs_kpk from "../Prokurorit/Kpk/AboutUs.vue";
import KomisionetKPK from "../Prokurorit/Kpk/KomisionetKPK.vue";
import SekretariatiKpk from "../Prokurorit/Kpk/SekretariatiKpk.vue";
import NjshppKpk from "../Prokurorit/Kpk/NjshppKpk.vue";
import KontaktKpk from "../Prokurorit/Kpk/KontaktKpk.vue";
import Prosecutors from "../Prokurorit/ProkuroriShtetit/ProsecutorView.vue";
import Autores from "../Prokurorit/ProkuroriShtetit/ProsecutorChief.vue";
import KomisionetKpk from "../Prokurorit/Kpk/KomisionetView.vue";

//PTh Prizren
import AboutPthPrizren from "../Prokurorit/PthPrizren/AboutPthPrizren.vue";
import KontaktPthPrizren from "../Prokurorit/PthPrizren/KontaktPthPrizren.vue";

// pth Ferizaj
import AboutPthFerizaj from "../Prokurorit/PthFerizaj/AboutPthFerizaj.vue";
import KontaktPthFerizaj from "../Prokurorit/PthFerizaj/KontaktPthFerizaj.vue";

//pth peje
import AboutPthPeje from "../Prokurorit/PthPeje/AboutPthPeje.vue";
import KontaktPthPeje from "../Prokurorit/PthPeje/KontaktPthPeje.vue";

//pth Mitrovice
import AboutPthMitrovice from "../Prokurorit/PthMitrovice/AboutPthMitrovice.vue";
import KontaktPthMitrovice from "../Prokurorit/PthMitrovice/KontaktPthMitrovice.vue";

//pth Gjilan
import AboutPthGjilan from "../Prokurorit/PthGjilan/AboutPthGjilan.vue";
import KontaktPthGjilan from "../Prokurorit/PthGjilan/KontaktPthGjilan.vue";


//pth Gjakova
import AboutPthGjakova from "../Prokurorit/PthGjakova/AboutPthGjakova.vue";
import KontaktPthGjakova from "../Prokurorit/PthGjakova/KontaktPthGjakova.vue";

import KontaktArtikle from "../components/share/KontaktArtikle.vue";

// Share
import video from '../components/pages/VideoGallery.vue';
import mundesipunesimi from '../components/pages/MundesiPunesimi.vue';
import CompetenciesTemplate from '../Prokurorit/share/CompetenciesView.vue';

//import ZyreComponet from "../components/share/ZyreComponet.vue";
import ZmnvView from "../Prokurorit/ProkuroriShtetit/ZmnvView.vue";
import ZmnvComponete from "../Prokurorit/ProkuroriShtetit/ZmnvComponete.vue";
import AllRaportetPages from "../components/pages/AllRaportetPages.vue";

import AboutUsSekretariati from '../Prokurorit/Sekretariati/ABoutUs_Sekretariati.vue';
import Departament_BurimeNjerezore from '../Prokurorit/Sekretariati/Departament_BurimeNjerezore.vue';
import Department_BuggjetFinanca from '../Prokurorit/Sekretariati/Department_BugjetFinanca.vue';
import Department_Administrat from '../Prokurorit/Sekretariati/Department_Administrat.vue';
import Department_Teknologji from "@/Prokurorit/Sekretariati/Department_Teknologji.vue";
import Department_Ligjor from '../Prokurorit/Sekretariati/Deprartment_Ligjor.vue';
import Njesit_Sekretariati from '../Prokurorit/Sekretariati/NjesitView.vue';
import Drejtor_Sekretariati from '../Prokurorit/Sekretariati/ZyraDrejtorit.vue';
import KontaktArea from '../components/share/ContactPerson.vue';
import Departament_Integrimi from "@/Prokurorit/Sekretariati/Departament_Integrimi.vue";

import Administratoret from "@/Prokurorit/ProkuroriaApelit/AdministratoretMain.vue";

const routes = [
  {
    path: "/",
    component: SistemiProkurorial,
    children: [
      {
        path: "",
        component: HomeView,
      },
      {
        path: "/artikulli/:id",
        name: "lajm",
        component: PostArtikulli,
      },
      {
        path: "/kontakt/:id",
        name: "kontakt",
        component: KontaktArtikle,
      },
      {
        path: "/article",
        name: "article",
        component: ZmnvView,
      },
      {
        path: "/report/:id",
        name: "raport",
        component: postReport,
      },
      {
        path: "/viktimat-e-krimit",
        name: "Postet",
        component: ViktimateKrimit,
      },
      {
        path: "/legislation-page",
        name: "legislation",
        component: LegislationPage,
      },
      {
        path: "/test",
        name: "test",
        component: LegislationPage,
      },
      {
        path: "/legislation-show/:prokuroriaId?/:documentTypeId?",
        name: "legislationshow",
        component: Legislation,
      },
      {
        path: "/documentet/:documentTypeId?/:title?",
        name: "Documentet",
        component: DocumentPage,
      },
      {
        path: "/vleresimi",
        name: "vleresimi",
        component: VlersimiPerformances,
      },
      {
        path: "/documents/:documentTypeId?/:title?",
        name: "documents",
        component: VendimetPage,
      },
      {
        path: "/latestnews",
        name: "latestnews",
        component: LatestNewsPage,
      },
      {
        path: "/disiplinimi/:title?",
        name: "disiplinimi",
        component: disiplinimi,
      },
      {
        path: "/etika",
        name: "etika",
        component: Etika,
      },
      {
        path: "/gallery",
        name: "gallery",
        component: gallery,
      },
      {
        path: "/zkpshaboutus",
        name: "zkpshaboutus",
        component: aboutus_zkpsh,
      },
      {
        path: "/zkpshchiefprosecutor",
        name: "zkpshchiefprosecutor",
        component: ProsecutorChief,
      },
      {
        path: "/zkpshprosecutors",
        name: "zkpshprosecutors",
        component: Prosecutors,
      },

      {
        path: "/prokuroret/:categoryId?/:pozitaid?",
        name: "prokuroret",
        component: Autores,
      },
      {
        path: "/administratoret/:categoryId?",
        name: "administratoret",
        component: Administratoret,
      },
      {
        path: "/coordinators",
        name: "coordinators",
        component: Coordinatorszkpsh,
      },
      {
        path: "/zmnvzkpsh",
        name: "zmnvzkpsh",
        component: zmnvzkpsh,
      },
      {
        path: "/njnp_zkpsh",
        name: "njnp_zkpsh",
        component: njnpzkpshview,
      },
      {
        path: "/zra_zkpsh",
        name: "zra_zkpsh",
        component: zrazkpsh,
      },
      {
        path: "/zkp_zkpsh",
        name: "zkp_zkpsh",
        component: zkp_zkpsh,
      },
      {
        path: "/marredheniamepublikun_zkpsh",
        name: "marredheniamepublikun_zkpsh",
        component: marredheniamepublikun,
      },
      {
        path: "/kontakti_zkpsh",
        name: "kontakt_zkpsh",
        component: kontakt_zkpsh,
      },
      {
        path: "/aboutus_pa",
        name: "aboutuspa",
        component: aboutus_pa,
      },
      {
        path: "about_pa",
        name: "aboutus_pa",
        component: AboutUsPa,
      },
      {
        path: "/pachiefprosecutor",
        name: "pachiefprosecutor",
        component: chief_pa,
      },
      {
        path: "/kontakt_pa",
        name: "kontakt_pa",
        component: kontakt_pa,
      },
      {
        path: "/aboutus_psold",
        name: "aboutusps",
        component: aboutus_ps,
      },
      {
        path: "/aboutus_ps",
        name: "aboutus_ps",
        component: AboutUsPs,
      },
      {
        path: "/pschiefprosecutor",
        name: "pschiefprosecutor",
        component: chief_ps,
      },
      {
        path: "/kontakt_ps",
        name: "kontakt_ps",
        component: kontakt_ps,
      },
      {
        path: "/aboutus_pthprishtineolg",
        name: "aboutus_pthprishtine",
        component: aboutus_pthprishtine,
      },
      {
        path: "/aboutus_pthprishtine",
        name: "aboutus_pthprishtine",
        component: AboutUsPthPrishente,
      },
      {
        path: "/pthprishtinechiefprosecutor",
        name: "pthprishtinechiefprosecutor",
        component: chief_pthprishtine,
      },
      {
        path: "/kontakt_pthprishtineold",
        name: "kontakt_pthprishtine",
        component: kontakt_pthprishtine,
      },
      {
        path: "/kontakt_pthprishtine",
        name: "kontakt_pthprishtine",
        component: KontaktPthPrishtine,
      },
      {
        path: "/about_kpk",
        name: "about_kpk",
        component: AboutUs_kpk,
      },
      {
        path: "komisionet_kpk",
        name: "komisionet_kpk",
        component: KomisionetKPK,
      },
      {
        path: "/sekretariati_kpk",
        name: "sekretariati_kpk",
        component: SekretariatiKpk,
      },
      {
        path: "/njshpp_kpk",
        name: "njshpp_kpk",
        component: NjshppKpk,
      },
      {
        path: "/kontakt_kpk",
        name: "kontakt_kpk",
        component: KontaktKpk,
      },
      {
        path: "/aboutus_pthprizren",
        name: "aboutus_pthprizren",
        component: AboutPthPrizren,
      },
      {
        path: "/kontakt_pthprizren",
        name: "kontakt_pthprizren",
        component: KontaktPthPrizren,
      },
      {
        path: "/aboutus_pthferizaj",
        name: "aboutus_pthferizaj",
        component: AboutPthFerizaj,
      },
      {
        path: "/kontakt_pthferizaj",
        name: "kontakt_pthferizaj",
        component: KontaktPthFerizaj,
      },
      {
        path: "/aboutus_pthpeje",
        name: "aboutus_pthpeje",
        component: AboutPthPeje,
      },
      {
        path: "/kontakt_pthpeje",
        name: "kontakt_pthpeje",
        component: KontaktPthPeje,
      },
      {
        path: "/aboutus_pthmitrovice",
        name: "aboutus_pthmitrovice",
        component: AboutPthMitrovice,
      },
      {
        path: "/kontakt_pthmitrovice",
        name: "kontakt_pthmitrovice",
        component: KontaktPthMitrovice,
      },
      {
        path: "/aboutus_pthgjilan",
        name: "aboutus_pthgjilan",
        component: AboutPthGjilan,
      },
      {
        path: "/kontakt_pthgjilan",
        name: "kontakt_pthgjilan",
        component: KontaktPthGjilan,
      },
      {
        path: "/aboutus_pthgjakova",
        name: "aboutus_pthgjakova",
        component: AboutPthGjakova,
      },
      {
        path: "/kontakt_pthgjakova",
        name: "kontakt_pthgjakova",
        component: KontaktPthGjakova,
      },
      {
        path: "/video",
        name: "video",
        component: video,
      },
      {
        path: "/punesimi",
        name: "punesimi",
        component: mundesipunesimi,
      },
      {
        path: "/zmnvcomponete",
        name: "zmnvcomponete",
        component: ZmnvComponete,
      },
      {
        path: "/raports",
        name: "raports",
        component: AllRaportetPages,
      },
      {
        path: "/komisionet_kpk",
        name: "komisionet_kpk",
        component: KomisionetKpk,
      },
      {
        path: "/competencies",
        name: "competencies",
        component: CompetenciesTemplate,
      },
      {
        path: "/aboutus_sekretariati",
        name: "aboutus_sekretariati",
        component: AboutUsSekretariati,
      },
      {
        path: "/departamenti_per_burime_njerezore",
        name: "departamenti_per_burime_njerezore",
        component: Departament_BurimeNjerezore,
      },
      {
        path: "/departamenti_per_burime_financiar",
        name: "departamenti_per_burime_financiar",
        component: Department_BuggjetFinanca,
      },
      {
        path: "/departamenti_per_administrative",
        name: "departamenti_per_administrative",
        component: Department_Administrat,
      },
      {
        path: "/departamenti_per_teknologji",
        name: "departamenti_per_teknologji",
        component: Department_Teknologji,
      },
      {
        path: "/departament_integrimi",
        name: "departament_integrimi",
        component: Departament_Integrimi,
      },
      {
        path: "/departamenti_ligjor",
        name: "departamenti_ligjor",
        component: Department_Ligjor,
      },
      {
        path: "/njesit",
        name: "njesit",
        component: Njesit_Sekretariati,
      },
      {
        path: "/zyra_drejtorit",
        name: "zyra_drejtorit",
        component: Drejtor_Sekretariati,
      },
      {
        path: "/contact-area",
        name: "contact-area",
        component: KontaktArea,
      },
      {
        path: "/kujdestarit-contact",
        name: "kujdestarit-contact",
        component: KujdestaritContact,
      },
      {
        path: "/zmnv-contact",
        name: "zmnv-contact",
        component: zmnvcontact,
      },
      {
        path: "/:pathMatch(.*)*",
        redirect: "/",
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
